import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import Form from "react-bootstrap/Form";
import { Col } from "react-bootstrap";

const BootCheckbox = (props) => {
  const {
    label,
    name,
    rules,
    control,
    changehandler,
    value,
    defaultValue,
    disabled,
    className,
    labelClassName,
    size,
  } = props;

  return control ? (
    <Col className="bg-gray-600">
      <Form.Label htmlFor={name}>{label}</Form.Label>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue || false}
        render={({ field }) => (
          <Form.Switch
            type="checkbox"
            id={name}
            className={`${className || ""}`}
            style={{
              display: "flex",
              marginLeft: "2rem",
              marginTop: "-2px"
            }}
          >
            <Form.Check.Input
              {...field}
              type="checkbox"
              disabled={disabled}
              checked={field.value}
              size={size}
              onChange={(e) => {
                field.onChange(e.target.checked);
                changehandler?.(e.target.checked);
              }}
            />

          </Form.Switch>
        )}
        rules={rules}
      />
    </Col>
  ) : (
    <Form.Check type="checkbox" id={name} className={`${className || ""}`}>
      <Form.Check.Input
        type="checkbox"
        name={name}
        disabled={disabled}
        checked={value || false}
        onChange={(e) => changehandler?.(e.target.checked)}
      />
      <Form.Check.Label className={`${labelClassName || ""}`}>
        {label}
      </Form.Check.Label>
    </Form.Check>
  );
};

BootCheckbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  control: PropTypes.object,
  rules: PropTypes.object,
  changehandler: PropTypes.func,
  value: PropTypes.bool,
  defaultValue: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  size: PropTypes.oneOf(["sm", "lg"]),
};

BootCheckbox.defaultProps = {
  label: "",
  disabled: false,
  defaultValue: false,
  className: "",
  labelClassName: "text-700 mb-1",
};

export default BootCheckbox;
